module.exports = __webpack_public_path__ + "img/sk.26e83226.svg";